import { Box, Button, Theme } from '@mui/material';
import Logo from '../../assets/images/new-logo-lrg.svg';
import CloseIcon from '@mui/icons-material/Close';

import MobileNavListComponent from './MobileNavListComponent';
import {
  InlineContainer,
  LogoImg,
  LogoWrapper,
} from '../../styled-components/GlobalStyledComponents';
import { LogoutButton } from '../Auth0LoginComponents/Buttons/LogoutButton';
import { ProfileIconWrapper } from '../../styled-components/NavigationStyledComponents';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Modal from '../UI/Popup/BackdropComponent';
import { LogoutOverlay } from '../../styled-components/NotificationModalStyledComponents';
import { useState } from 'react';
import useDetectResize from '../../hooks/useDetectResize';
import Card from '../UI/Card/CardComponent';
import { rtkFetchUserInfo } from '../../store/slices/individualSlice';
import { useAppSelector } from '../../store/store';
import MobileHeaderComponent from '../SharedComponents/MobileHeaderComponent';
import { LogoutWrapperBox } from '../../styled-components/GlobalStyledComponents';

const MobileNavigationComponent = (props: {
  onToggleNavigation: () => void;
  theme: Theme;
  colorMode: { toggleColorMode: () => void };
}) => {
  const [dropDownProfile, setDropDownProfile] = useState<boolean>(false);
  const { browserWindow } = useDetectResize();
  const myDetails = useAppSelector(rtkFetchUserInfo);

  return (
    <Box
      className="nav-menu"
      sx={{
        position: 'absolute',
        height: '100vh',
        width: '100%',
        zIndex: 10,
        background: '#e4f2f6',
        overflow: 'hidden',
        padding: '0.75em',
        top: 0,
        left: 0,
      }}
    >
      <MobileHeaderComponent
        onToggleNavigation={props.onToggleNavigation}
        theme={props.theme}
        colorMode={props.colorMode}
        isNavMenu={true}
      />

      <Box sx={{ textAlign: 'center', marginTop: '50px' }}>
        <MobileNavListComponent onToggleSelectNagivation={props.onToggleNavigation} />
      </Box>
    </Box>
  );
};

export default MobileNavigationComponent;

export const MJMHeaderLogo = (props: { Logo: string }) => {
  return (
    <LogoWrapper className="logo-wrpr">
      <LogoImg
        src={props.Logo}
        alt="MyJobMatch Logo with a tagline that says 'Building Connections for an Inclusive Future"
      />
    </LogoWrapper>
  );
};

export const ProfileAndLogoutComponent = () => {
  const cardStyle = {
    height: 'fit-content',
    minWidth: '120px',
    background: 'white',
    color: 'black',
    maxWidth: '450px',
    display: 'inline-grid',
    borderRadius: '10px',
    border: '2px solid lightgray',
    marginTop: '2px',
    animation: 'rotateMenu 250ms ease-in',
    marginLeft: '22%',
  };

  return (
    <LogoutWrapperBox>
      <LogoutButton />
    </LogoutWrapperBox>
  );
};
